import React, { useState } from 'react';

interface GuidelinesProps {
  onAccept: () => void;
  onClose: () => void;
}

const guidelinesList = [
  'Only students of MLRIT(MLID) can participate in the tournament.',
  'All 5 players of the team must be present 10 minutes before their scheduled match time.',
  'Respect all participants, organizers, and referees. Toxic behavior will not be tolerated.',
  'Use of any unauthorized software or cheats will result in immediate disqualification.',
  'Teams must play with the roster submitted during registration.',
  'Decisions by Apex MLRIT are final and binding.',
  'Players must use their own devices and accounts. Sharing accounts is strictly prohibited.',
  'By registering, you agree to your gameplay being recorded for promotional purposes.',
  'Failure to comply with the rules may result in penalties or disqualification.'
];

const Guidelines: React.FC<GuidelinesProps> = ({ onAccept, onClose }) => {
  const [accepted, setAccepted] = useState(false);

  return (
    <div className="w-full max-w-lg mx-auto bg-gray-900/90 border-2 border-red-500/40 rounded-xl p-8 shadow-[0_0_30px_rgba(239,68,68,0.25)] text-white relative">
      <h2 className="text-2xl font-bold text-red-400 mb-4 text-center uppercase tracking-wider">Tournament Guidelines</h2>
      <ul className="list-decimal list-inside space-y-3 text-gray-200 mb-6 text-left">
        {guidelinesList.map((rule, idx) => (
          <li key={idx} className="pl-1">{rule}</li>
        ))}
      </ul>
      <div className="flex items-center mb-6">
        <input
          id="accept-guidelines"
          type="checkbox"
          checked={accepted}
          onChange={e => setAccepted(e.target.checked)}
          className="form-checkbox h-5 w-5 text-red-500 bg-gray-800 border-gray-600 focus:ring-red-500 transition duration-200 mr-3"
        />
        <label htmlFor="accept-guidelines" className="text-gray-300 select-none cursor-pointer">
          I have read and agree to all the guidelines above.
        </label>
      </div>
      <div className="flex justify-between gap-4">
        <button
          onClick={onClose}
          className="px-5 py-2 rounded-lg bg-gray-700 text-gray-300 hover:bg-gray-600 transition-colors border border-gray-600"
        >
          Cancel
        </button>
        <button
          onClick={onAccept}
          disabled={!accepted}
          className={`px-6 py-2 rounded-lg font-bold transition-colors border-2 border-red-500/60 shadow-[0_0_10px_rgba(239,68,68,0.15)] ${
            accepted
              ? 'bg-red-600 text-white hover:bg-red-700' 
              : 'bg-gray-700 text-gray-400 cursor-not-allowed border-gray-700'
          }`}
        >
          Accept & Continue
        </button>
      </div>
    </div>
  );
};

export default Guidelines;
